import { Role } from "../../../helpers/role";
export const DealerMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "dealer",
    role: [Role.Dealer],
  },
  {
    title: "Sign-up",
    icon: "mdi-clipboard-check",
    code: "main-sign-up",
    role: [Role.Dealer],
    submenu: [
      {
        title: "For Confirmation",
        icon: "",
        to: "for-confirmation",
        code: "for-confirmation",
        role: [Role.Dealer],
      },
      {
        title: "Pay Later",
        icon: "",
        to: "pay-later",
        code: "sign-up",
        badge: {
          status: true,
          value: "paylater",
        },
        role: [Role.Dealer],
      },

      {
        title: "For Installation",
        icon: "",
        to: "for-installation",
        code: "for-installation",
        badge: {
          status: true,
          value: "forInstallation",
        },
        role: [Role.Dealer],
      },

      {
        title: "Installed / Activated",
        icon: "",
        to: "installed-activated",
        code: "installed-activated",
        role: [Role.Dealer],
      },
    ],
  },
  {
    title: "Activations",
    icon: "mdi-archive-check",
    to: "activated-list",
    code: "activated-list",
    role: [Role.Dealer],
  },

  {
    title: "Top-up Report",
    icon: "mdi-briefcase-download",
    code: "top-up",
    role: [Role.Dealer],
    submenu: [
      {
        title: "Per Dealer",
        icon: "",
        to: "per-dealer",
        code: "per-dealer",
        role: [Role.Dealer],
      },
    ],
  },

  {
    title: "Report",
    icon: "mdi-chart-line",
    code: "sales-report",
    role: [Role.Dealer],
    submenu: [
      {
        title: "Subscribers",
        icon: "",
        to: "subscribers",
        code: "report-top-up",
        role: [Role.Dealer],
      },

      {
        title: "Sign-up / Installed",
        icon: "",
        to: "report-sign-up",
        code: "report-sign-up",
        role: [Role.Dealer],
      },
      {
        title: "Installation",
        icon: "",
        to: "report-installation",
        code: "report-installation",
        role: [Role.Dealer],
      },
      {
        title: "Monthly Sales",
        icon: "",
        to: "monthly-sales",
        code: "report-top-up",
        role: [Role.Dealer],
      },
    ],
  },

  {
    title: "Retailer",
    icon: "mdi-store-marker",
    // to: "retailers",
    code: "retailers",
    role: [Role.Dealer],
    submenu: [
      {
        title: "List",
        icon: "",
        to: "retailers",
        code: "ibas-user-list",
        role: [Role.Dealer],
      },

      {
        title: "Sales Report",
        icon: "",
        to: "sales-report",
        code: "ibas-user-list",
        role: [Role.Dealer],
      },

      {
        title: "Retailer Transactions",
        icon: "",
        to: "retailer-transactions",
        code: "retailer-transactions",
        role: [Role.Dealer],
      },
    ],
  },

  {
    title: "IBAS User",
    icon: "mdi-account-multiple",
    code: "ibas-user",
    role: [Role.Dealer],
    submenu: [
      {
        title: "List",
        icon: "",
        to: "ibas-user-list",
        code: "ibas-user-list",
        role: [Role.Dealer],
      },
    ],
  },
];
